import cookieHandler from "AtomicUtils/cookieHandler"

export const gtmEventTypes = {
  SUBMIT_LOGIN: "FED-MYMAZDA2-001",
  CREATE_ACCOUNT: "FED-MYMAZDA2-002",
  CONTACT_US: "FED-MYMAZDA2-003",
  DEACTIVATE_ACCOUNT: "FED-MYMAZDA2-004",
  CHECK_EMAIL_REGISTER: "FED-MYMAZDA2-005",
  CREATE_PASSWORD: "FED-MYMAZDA2-006",
  CONTINUE_TO_MYMAZDA: "FED-MYMAZDA2-007",
  SUBMIT_REGISTER: "FED-MYMAZDA2-008",
  CAROUSEL_CLICK: "FED-MYMAZDA2-009",
  SERVICE_HISTORY_CLICK: "FED-MYMAZDA2-010",
  CALCULATOR_CLICK: "FED-MYMAZDA2-011",
  CALCULATOR_REQUEST_SERVICE: "FED-MYMAZDA2-012"
}

const pageCategories = {
  home: "MyMazda - Home",
  getInTouch: "MyMazda - Get In Touch",
  manage: "MyMazda - Manage Account",
  register: "MyMazda - Create Account",
  servicing: "MyMazda - Servicing"
}

export const gtmEvents = {
  [gtmEventTypes.SUBMIT_LOGIN]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.SUBMIT_LOGIN,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.SUBMIT_LOGIN,
    pageCategory: pageCategories.home,
    pageAction: `LOG IN BLOCK - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CREATE_ACCOUNT]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CREATE_ACCOUNT,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CREATE_ACCOUNT,
    pageCategory: pageCategories.home,
    pageAction: `CREATE AN ACCOUNT BLOCK - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CONTACT_US]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CONTACT_US,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CONTACT_US,
    pageCategory: pageCategories.home,
    pageAction: `CREATE AN ACCOUNT BLOCK - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.DEACTIVATE_ACCOUNT]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.DEACTIVATE_ACCOUNT,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.DEACTIVATE_ACCOUNT,
    pageCategory: pageCategories.manage,
    pageAction: `DEACTIVATE ACCOUNT - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CHECK_EMAIL_REGISTER]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CHECK_EMAIL_REGISTER,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CHECK_EMAIL_REGISTER,
    pageCategory: pageCategories.register,
    pageAction: `REGISTRATION FORM - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.SUBMIT_REGISTER]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.SUBMIT_REGISTER,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.SUBMIT_REGISTER,
    pageCategory: pageCategories.register,
    pageAction: `CREATE ACCOUNT - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CREATE_PASSWORD]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CREATE_PASSWORD,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CREATE_PASSWORD,
    pageCategory: pageCategories.register,
    pageAction: `CREATE PASSWORD - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CONTINUE_TO_MYMAZDA]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CONTINUE_TO_MYMAZDA,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CONTINUE_TO_MYMAZDA,
    pageCategory: pageCategories.register,
    pageAction: `MYMAZDA ACCOUNT CREATED - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CAROUSEL_CLICK]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CAROUSEL_CLICK,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CAROUSEL_CLICK,
    pageCategory: pageCategories.servicing,
    pageAction: `CAROUSEL - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.SERVICE_HISTORY_CLICK]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.SERVICE_HISTORY_CLICK,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.SERVICE_HISTORY_CLICK,
    pageCategory: pageCategories.servicing,
    pageAction: `HISTORY - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CALCULATOR_CLICK]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CALCULATOR_CLICK,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CALCULATOR_CLICK,
    pageCategory: pageCategories.servicing,
    pageAction: `CALCULATOR - Clicked "${buttonText.toUpperCase()}"`
  }),
  [gtmEventTypes.CALCULATOR_REQUEST_SERVICE]: ({
    buttonText
  }) => ({
    type: gtmEventTypes.CALCULATOR_REQUEST_SERVICE,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.CALCULATOR_REQUEST_SERVICE,
    pageCategory: pageCategories.servicing,
    pageAction: `CALCULATOR FORM - Clicked "${buttonText.toUpperCase()}"`
  })
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/mymazda2-duck.js